import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import Global from '../../../../../store/global-selectors';

import style from '../style.module.less';

export const AlertsLoadMore = ({ isLoading, onLoadMore, fetchedOrderAlertCount }) => {
  const orderAlertCount = useSelector(Global.selectOrdersNavOrderAlertCount);
  const shouldRenderButton = orderAlertCount > fetchedOrderAlertCount;
  if (!shouldRenderButton) {
    return null;
  }
  return (
    <div className={style['alerts-load-more']}>
      {isLoading && (
        <div className={style['loading-icon-wrap']}>
          <LoadingIndicator className={style['loading-icon']} />
        </div>
      )}
      {!isLoading && (
        <Button className={style['load-more-button']} onClick={onLoadMore} theme={THEME_CONSTANTS.tertiary}>
          <FormattedMessage defaultMessage='Load More' description='alertsGridButtons.loadMore' id='2n9a8K' />
        </Button>
      )}
    </div>
  );
};

AlertsLoadMore.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onLoadMore: PropTypes.func.isRequired,
  fetchedOrderAlertCount: PropTypes.number.isRequired,
};
